"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _body = require("./components/body");

var _footer = require("./components/footer");

var VariantMap = {
  mainBody: {
    ExtensiveSitemap: _body.ExtensiveSitemapBody,
    CenterStacked: _body.CenterStackedBody,
    BasicFishermanBanner: _body.BasicFishermanBannerBody,
    CenterStackedV2: _body.CenterStackedVTwoBody,
    Simple: _body.SimpleBody,
    Services: _body.ServicesBody,
    SubscriptionBanner: _body.SubscriptionBannerBody
  },
  footer: {
    ExtensiveSitemap: _footer.ExtensiveSitemapFooter,
    CenterStacked: _footer.CenterStackedFooter,
    BasicFishermanBanner: _footer.BasicFishermanBannerFooter,
    CenterStackedV2: _footer.CenterStackedVTwoFooter,
    Simple: _footer.SimpleFooter,
    Services: _footer.ServicesFooter,
    SubscriptionBanner: _footer.SubscriptionBannerFooter
  }
};
var _default = VariantMap;
exports["default"] = _default;